"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawalRequest = void 0;
var WithdrawalRequest = /** @class */ (function () {
    function WithdrawalRequest() {
    }
    return WithdrawalRequest;
}());
exports.WithdrawalRequest = WithdrawalRequest;
;
//# sourceMappingURL=withdrawal.request.js.map